import { createAction, props } from '@ngrx/store';

/** Trust settings applied to inbound users from external tenants. */
export interface CrossTenantInboundTrust {
    isMfaAccepted?: boolean;
    isCompliantDeviceAccepted?: boolean;
    isHybridAzureADJoinedDeviceAccepted?: boolean;
    isCompliantNetworkAccepted?: boolean;
}

/** A single access-control partition (users/groups or applications) of a B2B setting. */
export interface CrossTenantAccessPartition {
    accessType?: 'allowed' | 'blocked';
    targets?: Array<{ target: string; targetType: string }>;
}

/** One B2B direction (inbound/outbound) split into users-and-groups and applications. */
export interface CrossTenantB2bSetting {
    usersAndGroups?: CrossTenantAccessPartition;
    applications?: CrossTenantAccessPartition;
}

/**
 * The default configuration object returned by
 * `GET /policies/crossTenantAccessPolicy/default`.
 */
export interface CrossTenantAccessPolicyDefault {
    id?: string;
    isServiceDefault?: boolean;
    blockServiceProviderOutboundAccess?: boolean;
    inboundTrust?: CrossTenantInboundTrust;
    b2bCollaborationInbound?: CrossTenantB2bSetting;
    b2bCollaborationOutbound?: CrossTenantB2bSetting;
    b2bDirectConnectInbound?: CrossTenantB2bSetting;
    b2bDirectConnectOutbound?: CrossTenantB2bSetting;
    tenantRestrictions?: CrossTenantB2bSetting & { devices?: unknown };
}

export const loadCrossTenantAccessPolicy = createAction(
    '[Graph/cross-tenant access policy] Load Cross-Tenant Access Policy',
    props<{ _tenant: string }>(),
);

export const loadCrossTenantAccessPolicySuccess = createAction(
    '[Graph/cross-tenant access policy] Load Cross-Tenant Access Policy Success',
    props<{ _tenant: string; policy: CrossTenantAccessPolicyDefault | null }>(),
);

export const loadCrossTenantAccessPolicyFailure = createAction(
    '[Graph/cross-tenant access policy] Load Cross-Tenant Access Policy Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateCrossTenantAccessPolicy = createAction(
    '[Graph/cross-tenant access policy] Update Cross-Tenant Access Policy',
    props<{ _tenant: string; policy: Partial<CrossTenantAccessPolicyDefault> }>(),
);

export const updateCrossTenantAccessPolicySuccess = createAction(
    '[Graph/cross-tenant access policy] Update Cross-Tenant Access Policy Success',
    props<{ _tenant: string; policy: CrossTenantAccessPolicyDefault }>(),
);

export const updateCrossTenantAccessPolicyFailure = createAction(
    '[Graph/cross-tenant access policy] Update Cross-Tenant Access Policy Failure',
    props<{ _tenant: string; error: any }>(),
);
